import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/incoming_calls/incoming_call.vue'

export default class extends Controller {
  static values = {
    incomingCall: Object
  }

  connect() {
    const props = {
      incomingCall: this.incomingCallValue
    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
